<div class="container-fluid bg-white vh-100 p-0 position-relative">
  <ClientLogo v-if="this.$route.name != 'behalf_application'" />
  <BreadCrumb label="Facial Biometrics Verification" />

  <!-- LivenessCheck Component -->
    <LivenessCheck v-show="showCamera" ref="livenessCheck" :id_number="id_number" @photo-captured="handlePhotoCaptured" />

  <!-- Initial Form View -->
  <div class="d-flex justify-content-center align-items-center min-vh-50" v-if="!showCamera">
    <div class="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5 p-1">
      <div class="d-flex align-items-center mb-5">
        <span><i class="text-muted bi bi-question-circle me-2"></i></span>
        <span class="text-muted text-xs">
          A liveness check helps ensure you're physically present during verification by analyzing
          facial movements or biometric data, preventing the use of photos or videos.
        </span>
      </div>
      <!-- Initial Form View -->
      <div v-if="!showInstructions">
        <div class="text-danger mt-3 text-xss fw-bold d-flex justify-content-center min-vh-50" role="alert">
          <i class="fas fa-exclamation-circle me-2"></i>
          <small>Please make sure you have your camera enabled!</small>
        </div>

        <div v-if="showNameInputs" class="row mb-3 mt-3">
          <div class="col-md-6">
            <div class="form-group">
              <label for="first_name" class="form-label fw-bold text-xxs">
                First Name(s) <span class="text-danger fw-bold">*</span>
              </label>
              <input 
                id="first_name" 
                type="text"
                class="form-control text-xxs rounded-small p-2 shadow-sm"
                v-model="first_name" 
                placeholder="Enter your first name"
                :disabled="is_field_disabled.first_name"
                @input="handle_input"
              >
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="last_name" class="form-label fw-bold text-xxs">
                Last Name <span class="text-danger fw-bold">*</span>
              </label>
              <input 
                id="last_name" 
                type="text"
                class="form-control text-xxs rounded-small p-2 shadow-sm"
                v-model="last_name" 
                placeholder="Enter your last name"
                :disabled="is_field_disabled.last_name"
                @input="handle_input"
              >
            </div>
          </div>
        </div>

        <!-- ID Number input -->
        <div class="form-group justify-content-center">
          <label for="id_number" class="form-label fw-bold text-xxs">
            ID Number <span class="text-danger fw-bold">*</span>
          </label>
          <input 
            id="id_number" 
            type="text"
            class="form-control mx-auto col-12 col-md-9 col-lg-8 text-xxs rounded-small p-2 shadow-sm justify-content-center"
            v-model="id_number" 
            placeholder="Enter an SA ID Number" 
            @input="handle_input" 
            maxlength="13"
            :disabled="is_field_disabled.id_number"
          >
          <div class="d-flex flex-column col-12 col-md-9 col-lg-8 mx-auto mt-3 text-center">
            <small v-if="error_message" class="text-danger fw-bold text-xs">
              {{ error_message }}
            </small>
            <small class="text-danger fw-bold text-xs d-none id-message">
              Please fill in this field
            </small>
            <small class="text-danger fw-bold text-xs d-none invalid-message">
              Please enter a valid ID number
            </small>
          </div>
        </div>
        <div class="text-center mt-3">
          <button 
            class="btn bg-green shadow-sm rounded-small text-xs fw-bold shadow mt-2 mt-md-0" 
            @click="id_check"
            :disabled="!isFormValid || loading"
          >
            Start Facial Recognition
          </button>
        </div>
      </div>

      <!-- Instructions View -->
      <div v-if="showInstructions" class="instructions-overlay" @click.self="closeInstructions">
        <div class="instructions-content">
          <ClientLogo class="mb-5" />
          <h6 class="mb-4 text-xss text-center">We need to verify your identity to secure your basic information.</h6>
          <h6 class="fw-bold text-center">Please read the below instructions carefully:</h6>
          <hr class="my-4">
          <ul class="instruction-list" style="text-align: left; padding-left: 20px;">
            <li class="d-flex align-items-center">
              <i class="fa fa-camera instruction-icon-color me-2"></i>
              <span>Ensure your camera is enabled</span>
            </li>
            <li class="d-flex align-items-center">
              <i class="fa fa-lightbulb instruction-icon-color me-2"></i>
              <span>Make sure you are in a well-lit area</span>
            </li>
            <li class="d-flex align-items-center">
              <i class="fa fa-glasses instruction-icon-color me-2"></i>
              <span>Remove any glasses, hats, or face coverings</span>
            </li>
            <li class="d-flex align-items-center">
              <i class="fa fa-user-circle instruction-icon-color me-2"></i>
              <span>Ensure you're the only person in frame</span>
            </li>
          </ul>
          <hr class="my-4">
          <div class="d-flex justify-content-center mt-4">
            <button class="btn bg-green shadow-sm rounded-small" @click="startFaceRecognition">
              Take Photo
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
